import React from 'react';
import { OverlayView } from '@react-google-maps/api';

interface IDistanceLabel {
  destinationCoordinates: { lat: number; lng: number };
  distance: string;
}

export const DistanceLabel: React.FC<IDistanceLabel> = ({
  destinationCoordinates,
  distance,
}) => {
  return (
    <OverlayView
      position={{
        lat: destinationCoordinates.lat - 0.0005,
        lng: destinationCoordinates.lng,
      }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div
        style={{
          width: '78px',
          background: 'black',
          color: 'white',
          padding: '4px 3px',
          borderRadius: '4px',
          fontSize: '11px',
          fontWeight: 'bold',
          textAlign: 'center',
          position: 'relative',
          left: '-38px',
          top: '5px',
        }}
      >
        {distance}
      </div>
    </OverlayView>
  );
};
